
export const appVersion = {
	name: 'coachway',
    timestamp: 'Fri, 11 Jul 2025 13:05:30 GMT',
    versionHash: '1752239130529',
    version: '2.3.1'
};
